"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var CheckCircle = function (_a) {
    var size = _a.size, title = _a.title, color = _a.color, svgProps = __rest(_a, ["size", "title", "color"]);
    return (react_1.default.createElement("svg", __assign({ stroke: "currentcolor", fill: "currentColor", strokeWidth: "0" }, svgProps, { width: size || '1rem', height: size || '1rem', viewBox: "0 0 24 24", style: __assign({ color: color }, svgProps.style), xmlns: "http://www.w3.org/2000/svg" }),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("g", { id: "check-circle" },
            react_1.default.createElement("path", { id: "Icon", d: "M8.20711 11.2929C7.81658 10.9024 7.18342 10.9024 6.79289 11.2929C6.40237 11.6834 6.40237 12.3166 6.79289 12.7071L8.20711 11.2929ZM10.5 15L9.79289 15.7071C10.1834 16.0976 10.8166 16.0976 11.2071 15.7071L10.5 15ZM17.2071 9.70711C17.5976 9.31658 17.5976 8.68342 17.2071 8.29289C16.8166 7.90237 16.1834 7.90237 15.7929 8.29289L17.2071 9.70711ZM21 12C21 16.9706 16.9706 21 12 21V23C18.0751 23 23 18.0751 23 12H21ZM12 21C7.02944 21 3 16.9706 3 12H1C1 18.0751 5.92487 23 12 23V21ZM3 12C3 7.02944 7.02944 3 12 3V1C5.92487 1 1 5.92487 1 12H3ZM12 3C16.9706 3 21 7.02944 21 12H23C23 5.92487 18.0751 1 12 1V3ZM6.79289 12.7071L9.79289 15.7071L11.2071 14.2929L8.20711 11.2929L6.79289 12.7071ZM11.2071 15.7071L17.2071 9.70711L15.7929 8.29289L9.79289 14.2929L11.2071 15.7071Z" }))));
};
exports.default = CheckCircle;
